import React from 'react';
import { defineMessages,FormattedMessage, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';
import { BodyText, Button, IllusEmployeeBag, Image, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardOrdersEmpty = (props: GiftCardOrdersEmptyProps) => {
  const { onPress } = props;

  const { formatMessage } = useIntl();

  return (
    <View style={styles.container}>
      <Image
        source={IllusEmployeeBag}
        aria-label={formatMessage(messages.illustrationAlt)}
        style={styles.illustration}
        contentFit="contain"
      />

      <View style={styles.innerContainer}>
        <BodyText bold sizeMatch={['16']} style={styles.text}>
          <FormattedMessage {...messages.title} />
        </BodyText>

        <BodyText sizeMatch={['16']} style={styles.text}>
          <FormattedMessage {...messages.text} />
        </BodyText>

        <Button
          size="large"
          palette="kaleLightest"
          aria-label={formatMessage(messages.ctaA11yLabel)}
          onPress={onPress}
          style={styles.cta}
        >
          <FormattedMessage {...messages.ctaLabel} />
        </Button>
      </View>
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  illustrationAlt: {
    defaultMessage: 'A person holding SG bag',
    description: 'Gift Cards | Empty State | Illustration alternative text',
  },
  title: {
    defaultMessage: 'No history',
    description: 'Gift Cards | Empty State | Title',
  },
  text: {
    defaultMessage: 'You will see your gifting history here.',
    description: 'Gift Cards | Empty State | Text',
  },
  ctaLabel: {
    defaultMessage: 'Send a gift card',
    description: 'Gift Cards | Empty State | "Send a gift card" CTA label',
  },
  ctaA11yLabel: {
    defaultMessage: 'Navigate to the "Gift Cards" screen',
    description: 'Gift Cards | Empty State | "Send a gift card" a11y label',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    paddingVertical: theme.spacing['12'],
    borderRadius: theme.radius.large,
    borderWidth: 1,
    borderColor: theme.colors.GRAY,
  },
  innerContainer: {
    maxWidth: '100%',
    rowGap: theme.spacing['6'],
  },
  illustration: {
    width: 200,
    height: 200,
  },
  text: {
    textAlign: 'center',
  },
  cta: {
    width: 342,
    maxWidth: '100%',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type GiftCardOrdersEmptyProps = {
  onPress: () => void;
};
